import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="React">
                <h1>React Native App Development Company in Dubai</h1>
              </div>
              <p className="main_para">
                Improve your mobile presence with TekRevol, the trusted React
                Native app development company for businesses in Dubai. We
                create flexible and powerful designs specifically honed to make
                your app shine in the online world. Increase your returns by
                choosing React Native, which holds a significant 38% market
                share and is a top choice for building apps that work well
                across different platforms.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your App Now!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
